//This set to use Production Mode or DevelopmentMode
export const IsProdMode = false;

export const IsEncryption = false;

export const IsQueryParamsEncryption = true;


// AESKey for encryption and decryption
export const Value1 = "P1Pw0sggFsebE+Tqt+REGQ==";

// AESIV for encryption and decryption
export const Value2 = "JIeoMo1pNWQHoF92sLQqyQ==";

export const IsCookieEncryption = true;

// Web URL Path

export const WebURLPath = "https://arbourhealthcaregroup.co.uk/pageManagement/";
export const WebPath = "https://arbourhealthcaregroup.co.uk/";


// Web URL Path

// export const WebURLPath = "http://localhost:3005/pageManagement/";
// export const WebPath = "http://localhost:3005/";

export const GoogleMapKey = "AIzaSyCT-iv_tIKc1sINLPPiPr5RTPpFTHHI1Y0";

export const Value3 = "AuthUserA111";

export const Value4 = "TokenA111";

export const IsStagingEnvironment = false;

export const WebToken= "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9";

//export const IsUnderMaintenance = false;
